import { render, staticRenderFns } from "./AddExpense.vue?vue&type=template&id=643be90a&scoped=true&lang=pug&"
import script from "./AddExpense.vue?vue&type=script&lang=js&"
export * from "./AddExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643be90a",
  null
  
)

/* custom blocks */
import block0 from "./AddExpense.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports